import React from 'react';
import classnames from 'classnames';
import { useMemoizedFn } from 'ahooks';
import { queryJumpable } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IBIDSNavigatorProps extends IBaseProps {
  url?: string;
}

const BIDSNavigator: React.FC<IBIDSNavigatorProps> = (props) => {
  const { style, className, url } = props;

  const handleNavigate = useMemoizedFn((e?: React.SyntheticEvent<HTMLAnchorElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (!queryJumpable(e)) return;
    if (!url) return;
    window.open(url);
  });

  return (
    <span style={style} className={classnames('dbg-studio-management-meetings-navigate-tips', className)}>
      If you need to update, please{' '}
      <a className="dbg-studio-management-meetings-navigate-linker" href={url} onClick={handleNavigate}>
        go to BIDS
      </a>
    </span>
  );
};

export default React.memo(BIDSNavigator);
